/**
 * Created by nijin on 27/6/17.
 */
import {Component, OnInit, ViewChild, Output, EventEmitter} from "@angular/core";
import {AppModalComponent} from "../../../shared/modal/modal";

@Component({
  selector: 'nuc-location-type-popup',
  styles: [`
        span.bold{
          font-weight: 600;
        }
        .modal-title{
          font-weight: 600;
          color: #ca2d2d;
          text-align: center;
        }
    `],
  template: `
         <app-modal #popup>
  <div class="app-modal-header">
    <h4 class="modal-title red">Alert!!</h4>
  </div>
  <div class="app-modal-body">
    <p>Do you want to change the <span class="bold">Location Format</span>?
    Current custom location configuration may not be saved.</p>
  </div>
  <div class="app-modal-footer">
    <div class="btn-group-1 text-center">
      <button class="btn btn-primary"  (click)="accept()" id="change">
        Change
      </button>
      <button class="btn btn-secondary" (click)="hide()" id="cancel">
        Cancel
      </button>
    </div>
  </div>
</app-modal>
     
   `
})
export class  LocationTypeChangeWarning implements OnInit {
  @ViewChild('popup') warningModal: AppModalComponent;
  @Output() onAccept: EventEmitter<any> = new EventEmitter<any>();
  @Output() onReject: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(){

  }

  accept(){
    this.onAccept.emit(true);
    this.hide();
  }

  open(){
    this.warningModal.open();
  }

  hide(){
    this.onReject.emit(false);
    this.warningModal.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/schema/shared/modal/location.type.change.confirmation.ts